import { ButtonList } from '@dixa/lib-shared-habla';
import { conversationChannelAttributes } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';
import { Channel } from 'lib-shared-types-channels';
import { useState } from 'react';

import {
  BanUserModal,
  BanUserModalOnCloseEvent,
} from 'components/shared/banUserModal/banUserModal';
import { BanUserResponse } from 'hooks/useBans/types';

export function BanUserButtonListItem(props: {
  user: User;
  channel: Channel;
  onModalOpen?: VoidFunction;
  csid?: number;
  ipAddress?: string;
  onBan?: (response: BanUserResponse) => void;
}) {
  const { channel, user, onBan, csid, ipAddress, onModalOpen } = props;
  const channelAttributes = conversationChannelAttributes.get(channel);
  const [isModalOpen, setModalOpen] = useState(false);

  function handleOnModalClose(event: BanUserModalOnCloseEvent) {
    setModalOpen(false);

    if (!event.canceled && event.response && onBan) {
      onBan(event.response);
    }
  }

  function handleOnModalOpen() {
    setModalOpen(true);
    onModalOpen && onModalOpen();
  }

  return (
    <>
      <ButtonList.Item icon="ban" onClick={handleOnModalOpen}>
        Ban from {channelAttributes?.prettyName}
      </ButtonList.Item>
      <BanUserModal
        user={user}
        channel={channel}
        csid={csid}
        ipAddress={ipAddress}
        isOpen={isModalOpen}
        onClose={handleOnModalClose}
      />
    </>
  );
}
